import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import native from '@/utils/native';


export default /*#__PURE__*/_defineComponent({
  __name: 'contract-redirect',
  setup(__props) {

onMounted(() => {
  setTimeout(() => {
    native.method.contractSignDone();
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})